"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Journey = void 0;
const nprogress_1 = __importDefault(require("nprogress"));
const helpers_1 = require("./helpers");
const getDefaultConfig_1 = __importDefault(require("./config/getDefaultConfig"));
const createJourneyComponent_1 = require("./createJourneyComponent");
const Button_1 = __importDefault(require("../components/Util/Button"));
const enhancedFetch_1 = require("./enhancedFetch");
// eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
const Router = helpers_1.optionalModule(() => require('next/router').Router);
class _Journey {
    constructor() {
        this.config = getDefaultConfig_1.default();
        this.nProgressConnected = false;
    }
    div(className) {
        return createJourneyComponent_1.createJourneyComponent(className, 'div');
    }
    button(className) {
        return createJourneyComponent_1.createJourneyComponent(className, Button_1.default);
    }
    setConfig(newConfig) {
        newConfig = newConfig instanceof Function ? newConfig(this.config) : newConfig;
        this.config = newConfig;
        this.update();
        return this;
    }
    icons() {
        return this.config.icons;
    }
    startPageLoader() {
        nprogress_1.default.start();
        if (helpers_1.hasNotch()) {
            nprogress_1.default.configure({
                // eslint-disable-next-line max-len
                template: '<div class="bar notch-mode" role="bar"><div class="peg notch-mode"></div></div><div class="spinner" role="spinner"><div class="spinner-icon notch-mode"></div></div>',
            });
        }
    }
    stopPageLoader() {
        nprogress_1.default.done();
    }
    update() {
        var _a;
        if (this.config.pageLoader && this.config.pageLoader === true && Router && !this.nProgressConnected) {
            const startLoader = () => this.startPageLoader();
            const stopLoader = () => this.stopPageLoader();
            Router.events.on('routeChangeStart', startLoader);
            Router.events.on('routeChangeComplete', stopLoader);
            Router.events.on('routeChangeError', stopLoader);
            this.nProgressConnected = true;
        }
        if ((_a = this.config.serversideBaseDomain) === null || _a === void 0 ? void 0 : _a.endsWith('/')) {
            this.config.serversideBaseDomain = this.config.serversideBaseDomain.slice(0, -1);
        }
    }
    appendConfig(config) {
        this.setConfig((prevConfig) => (Object.assign(Object.assign({}, prevConfig), config)));
    }
    formatResponse(resp) {
        return resp ? this.config.formatResponse(resp) : resp;
    }
    // eslint-disable-next-line class-methods-use-this
    post(url, body, options = {}) {
        return enhancedFetch_1.enhancedFetch(url, Object.assign({ method: 'POST', body }, options));
    }
    // eslint-disable-next-line class-methods-use-this
    put(url, body, options = {}) {
        return enhancedFetch_1.enhancedFetch(url, Object.assign({ method: 'PUT', body }, options));
    }
}
exports.Journey = new _Journey();
exports.Journey.update();
